import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import {
  BoolFilter,
  SearchRoutinesReq_OrderBy,
} from "gen/search/service/service_pb"
import { UUID } from "shared-ts/classes/uuid"
import { SortOrder } from "shared-ts/hooks/useSort/helpers"
import { WebUrl } from "shared-web/lib/webUrl"

export function routines(): WebUrl {
  return {
    pathname: "/pos/dooey/routines",
    query: {
      status: BoolFilter.TRUE.toString(),
      sort: SearchRoutinesReq_OrderBy.LAST_RUN_AT.toString(),
      order: SortOrder.Descending,
    },
  }
}

export function routine(id?: PBUUID): WebUrl {
  return {
    pathname: `/pos/dooey/routines/${UUID.idString(id)}`,
  }
}
